import React from 'react';
import rightSubHeaderImage from '../assets/Hero-img.png';
// import observer from '../utils/observer';

const RightSubHeader = () => {
  // const refValue = useRef(null);

  // useEffect(() => {
  //   observer(refValue, 'lazy-load-image');
  // }, [refValue]);

  return (
    <div className="right-subheader-container">
      <img
        className="right-subheader-image "
        src={rightSubHeaderImage}
        alt="more info"
        // ref={refValue}
      />
    </div>
  );
};

export default RightSubHeader;
